import { heroStats } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

export default function HeroSection() {
  return (
    <section id="top" className="relative overflow-hidden pb-16 pt-28 md:pb-24 md:pt-40">
      <div className="pointer-events-none absolute -right-24 top-24 h-72 w-72 rounded-full bg-accent-100/60 blur-3xl" />
      <div className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-primary-100/50 blur-3xl" />

      <div className="relative mx-auto grid w-full max-w-[1280px] items-center gap-14 px-4 md:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3.5 py-1.5 text-xs font-medium text-foreground-700">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-flashlight-fill text-sm text-primary-500" />
            </span>
            全网热点聚合 · 每日更新
          </span>

          <h2 className="mt-6 font-heading text-3xl font-bold leading-[1.35] tracking-tight text-foreground-950 md:text-[44px] md:leading-[1.3]">
            全网热点一次看全，
            <br className="hidden md:block" />
            黑料脉络顺着时间读
          </h2>

          <p className="mt-6 max-w-xl text-[15px] leading-8 text-foreground-700">
            44黑料区把娱乐、社会、财经等领域的爆料集中到一处，用 <strong className="font-semibold text-foreground-900">黑料聚合</strong> 的方式整理每日热门话题，再从零散信息里梳理出完整的 <strong className="font-semibold text-foreground-900">黑料大全</strong> 与 <strong className="font-semibold text-foreground-900">黑料汇总</strong>，点开就能跟上事件进度。
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <a
              href="#featured"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line text-base" />
              进入黑料区
            </a>
            <a
              href="#ranking"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-7 py-3.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-list-ordered text-base" />
              查看今日热门榜单
            </a>
          </div>

          <dl className="mt-12 grid grid-cols-1 gap-6 border-t border-background-200 pt-8 sm:grid-cols-3">
            {heroStats.map((stat) => (
              <div key={stat.label}>
                <dt className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                  {stat.value}
                </dt>
                <dd className="mt-1.5 text-sm text-foreground-600">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </Reveal>

        <Reveal delay={150}>
          <div className="relative">
            <div className="h-[360px] w-full overflow-hidden rounded-2xl border border-background-200 md:h-[540px]">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20overlapping%20torn%20paper%20layers%20and%20soft%20geometric%20shapes%20in%20warm%20vermillion%20amber%20and%20cream%20tones%20on%20a%20light%20paper%20background%2C%20subtle%20film%20grain%20texture%2C%20generous%20negative%20space%2C%20minimalist%20art%20direction%2C%20no%20text%2C%20high%20detail%2C%20harmonious%20balanced%20composition&width=1200&height=1000&seq=hl-hero-main&orientation=landscape"
                alt="44黑料区热点爆料聚合视觉图"
                title="44黑料区 黑料聚合 热点爆料"
                className="h-full w-full object-cover object-top"
              />
            </div>

            <div className="absolute -bottom-6 left-4 hidden w-60 rounded-xl border border-background-200 bg-background-50 p-4 sm:block md:left-8">
              <div className="flex items-center gap-2 text-xs font-medium text-foreground-600">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-refresh-line text-sm text-accent-600" />
                </span>
                今日已更新
              </div>
              <p className="mt-2 font-heading text-2xl font-bold text-foreground-950">
                128 <span className="text-sm font-medium text-foreground-600">条爆料</span>
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}